import _regeneratorRuntime from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { m as menuController } from './index5.js'; // Given a menu, return whether or not the menu toggle should be visible

var updateVisibility = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(menu) {
    var menuEl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return menuController.get(menu);

          case 2:
            menuEl = _context.sent;
            _context.t0 = menuEl;

            if (!_context.t0) {
              _context.next = 8;
              break;
            }

            _context.next = 7;
            return menuEl.isActive();

          case 7:
            _context.t0 = _context.sent;

          case 8:
            return _context.abrupt("return", !!_context.t0);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function updateVisibility(_x) {
    return _ref.apply(this, arguments);
  };
}();

export { updateVisibility as u };